import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function BenefitsSection() {
  const benefits = ['reducir despertares que son por hábitos/asociaciones', 'conseguir tramos de sueño más largos y predecibles', 'mejorar siestas (más estables, menos caos)', 'ordenar horarios sin rigidez: con ventanas de sueño', 'saber qué hacer cuando hay regresiones (sin pánico)', 'recuperar calma mental, porque ya no improvisas'];
  return <section className="py-10 md:py-16 px-4 md:px-6" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <div className="text-center mb-8 md:mb-12" data-id="element-4">
            <h2 className="text-2xl md:text-4xl font-serif mb-3 md:mb-4 text-gold" data-id="element-5">
              Lo que vas a lograr con este ebook
            </h2>
            <p className="text-base md:text-xl text-white/70" data-id="element-6">
              Dependiendo de la edad y situación de tu bebé, vas a poder:
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-7">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.08} direction="up" data-id="element-8">
              <div className="bg-navy-card p-4 md:p-6 rounded-xl md:rounded-2xl shadow-sm border border-navy-light flex items-start gap-3 h-full" data-id="element-9">
                <div className="mt-0.5 flex-shrink-0 bg-green-900/30 rounded-full p-1" data-id="element-10">
                  <svg className="w-4 h-4 md:w-5 md:h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-11">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-12" />
                  </svg>
                </div>
                <span className="text-base md:text-lg text-white/80" data-id="element-13">
                  {benefit}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-14">
          <div className="text-center mb-8 md:mb-12" data-id="element-15">
            <p className="text-lg md:text-2xl font-serif italic font-bold text-white" data-id="element-16">
              No te prometo un bebé "perfecto".{' '}
              <br className="hidden md:block" data-id="element-17" />
              <span className="text-gold" data-id="element-18">
                Te prometo un plan que se sostiene.
              </span>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.7} className="flex justify-center" data-id="element-19">
          <Button className="w-full md:w-auto" data-id="element-20">Empezar hoy</Button>
        </FadeIn>
      </div>
    </section>;
}